import { Button, Modal, Select } from "djuno-design";
import { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { useParams } from "react-router-dom";
import {
  aiAppSynchronizationAsync,
  selectAiAppsActionLoading,
} from "../../../../store/ai/deploys/appsSlice";
import {
  handleSynchronisation,
  selectShowSynchronisationModal,
} from "../../../../store/ai/deploys/appSlice";

export const synchronisationOptions = [
  {
    label: "push",
    value: "push",
  },
  {
    label: "pull",
    value: "pull",
  },
];

export const SynchronisationModal: React.FC = () => {
  const { appId } = useParams();
  const [sync, setSync] = useState<string>("push");
  const isOpen = useAppSelector(selectShowSynchronisationModal);
  const loading = useAppSelector(selectAiAppsActionLoading);

  const dispatch = useAppDispatch();
  const handleSubmitForm = () => {
    if (!appId) {
      return;
    }

    dispatch(
      aiAppSynchronizationAsync({
        id: appId,
        data: {
          direction: sync,
          volume: null, //TODO
        },
      })
    ).then((action) => {
      if (action.type === "ai-apps/datasync/fulfilled") {
        handleOnClose();
      }
    });
  };

  const handleOnClose = useCallback(() => {
    dispatch(handleSynchronisation({ status: false }));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      handleOnClose();
    };
  }, [handleOnClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnClose}
      contentClassName="!max-w-xl overflow-hidden "
      title="Synchronising data manually"
    >
      <div className="flex flex-col gap-3 mt-5">
        <Select
          label="Synchonisation type"
          tooltip={{
            content:
              "You can choose between a push, to sync to your data container or a pull, in the opposite direction.",
          }}
          options={synchronisationOptions}
          value={sync.toString()}
          onChange={(v) => setSync(v || "0")}
          buttonClassName="!border-slate-200 dark:!border-secondary-700 !pr-7"
          optionsClassName=" !max-h-none"
          className="!w-full"
        />
        <div className="flex justify-end gap-2 mt-8">
          <Button uiType="simple" onClick={handleOnClose}>
            Cancel
          </Button>
          <Button uiType="primary" onClick={handleSubmitForm} loading={loading}>
            Async
          </Button>
        </div>
      </div>
    </Modal>
  );
};
